<template>
 <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <h3>付款</h3>
      <!-- <div class="section payment-section">
        <div class="item"
          v-for="(item, index) in paymentMode"
          :key="index"
          :class="{'item-active': index == current}"
          @click="togglePayment(item.id, index)">
            <img src="@/assets/images/icon-alipay.png" class="icon" v-show="item.id == 1" />
            <img src="@/assets/images/icon-wechat.png" class="icon" v-show="item.id == 2" />
            <span class="item-name">{{item.name}}</span>
        </div>
      </div> -->
      <div class="payment-list">
        <div class="item collection-payment" :class="payType == 1 ? 'item-active' : ''" @click.stop="togglePayment(1)">
          <el-image :src="qrCodeUrl" fit="contain" class="qr-code"></el-image>
          <div class="info">
            <div class="name f-bold">收款码支付</div>
            <div class="tips">手机扫码支付</div>
          </div>
        </div>
        <div class="item" :class="payType == 2 ? 'item-active' : ''" @click.stop="togglePayment(2)">
          <div class="name account-name f-bold">对公账户转账：</div>
          <div class="row">
            <span class="label-name">开户名称</span>
            <span class="cont">奇点时代（深圳）科技有限公司</span>
          </div>
          <div class="row">
            <span class="label-name">账号</span>
            <span class="cont" v-clipboard:copy="'755957320410401'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">755957320410401<span class="copy-btn">复制</span></span>
          </div>
          <div class="row">
            <span class="label-name">开户行</span>
            <span class="cont">招商银行股份有限公司深圳科苑支行</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="btn-group">
        <div class="btn prev-btn" @click="goBack">上一步</div>
        <div class="btn confim-btn" @click="onSubmit">已付款</div>
        <!-- <div class="btn confim-btn disable-btn" v-if="!payType">已付款</div> -->
      </div>
    </div>
    <ContactBtn />
    <Loading :msg="'请扫收款码完成支付~'" :width="200" :height="100" v-if="isShowLoading" />
  </div>
</template>


<script>
import { ImagePreview } from 'vant';
import { getAnnualFeeInfo, getFkdateShopAnnualFee } from '@/api/baseinfo';

export default {
  name: 'payment',
  data () {
    return {
      isShowLoading: false,
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      paymentMode: [{
        id: 1,
        name: '支付宝支付',
      },{
        id: 2,
        name: '微信支付',
      }],
      payType: 1,  //  1、线上，扫码支付 2、线下，银行卡支付
      qrCodeUrl: undefined,
      shopCode: undefined,
      form: {}
    }
  },
  created() {
    this.mobileTerminal((data) => {
      this.isMobile = data;
    })
    this.shopCode = this.$route.query && this.$route.query.shopCode ? this.$route.query.shopCode : undefined;
    this.getFkdateShopAnnualFee();
  },
  methods: {
    togglePayment(val) {
      this.payType = val;
      // this.isShowLoading = false;
      // if(val == 1) {
      //   this.getAnnualFeeInfo();
      // }
    },
    toPreviewImg() {
      // 预览图片
      ImagePreview({
        images: [
          'https://img01.yzcdn.cn/vant/apple-1.jpg',
          'https://img01.yzcdn.cn/vant/apple-2.jpg',
        ],
        closeable: true,
        showIndicators: true,
        loop: true
      });
    },
    onCopySuccess() {
      this.Toast('复制成功');
    },
    onCopyError() {
      this.Toast('抱歉，复制失败！');
    },
    goBack() {
      this.$router.go(-1);
    },
    getFkdateShopAnnualFee() {
      let params = {
        shopCode: this.shopCode,
        payType: this.payType,
      }
      getFkdateShopAnnualFee(params).then(res =>{
        if(res.data && res.data.urlPath) {
          this.qrCodeUrl = res.data.urlPath;
        }
      })
    },
    getAnnualFeeInfo() {
      getAnnualFeeInfo(this.shopCode).then(res => {
        if(!res.data) return false;
        if(res.data.isPay == 1) {
          this.$router.push({
            path: '/distribution/baseinfo-auth?shopCode=' + this.shopCode
          })
        } else if(res.data.isPay == 0) {
          // this.isShowLoading = true;
          this.Toast('请先扫一扫收款码完成支付~')
        }
      })
    },
    onSubmit() {
      if(this.payType == 1) {
        this.getAnnualFeeInfo();
      } else {
        this.getFkdateShopAnnualFee();
        this.$router.push({
          path: '/distribution/baseinfo-auth?shopCode=' + this.shopCode
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    position: relative;
    h3{
      width: 16.7rem;
      margin: .8rem auto 1.4rem;
      font-size: 1.2rem;
      color: #222;
      text-align: left;
    }
  }
  .section{
    width: 16.7rem;
    margin: 0 auto;
  }
  .payment-section{
    .item{
      max-width: 16.7rem;
      background: #F4F9FD;
      border-radius: .5rem;
      border: .1rem solid #F4F9FD;
      margin-bottom: 1.4rem;
      padding: 1.2rem 1rem;
      box-sizing: border-box;
      cursor: pointer;
      @include flex-align();
      .icon{
        width: 1.2rem;
        height: 1.2rem;
      }
      .item-name{
        line-height: 1.2;
        font-size: .8rem;
        color: #222;
        margin-left: .75rem;
      }
    }
    .item-active{
      border: .1rem solid $base-color;
    }
  }
  .payment-list{
    .item{
      width: 15rem;
      height: 8.1rem;
      background: #FFFFFF;
      border-radius: .8rem;
      border: .1rem solid #D8E0F0;
      margin: 0 auto .5rem;
      padding: .8rem;
      // padding: 1.1rem .25rem 1.1rem 1.1rem;
      &:last-child{
        margin-bottom: 0;
      }
      &-active{
        border: .15rem solid $base-color;
      }
      .name{
        line-height: 1.4;
        font-size: 1.1rem;
        color: #222;
        margin-bottom: .4rem;
      }
      .account-name{
        margin-bottom: .8rem;
      }
    }
    .collection-payment{
      display: flex;
      align-items: center;
    }
    .qr-code{
      width: 5rem;
      height: 5rem;
      margin-right: 1rem;
    }
    .info{
      .tips{
        line-height: 1.4;
        font-size: .8rem;
        color: #8F8F94;
        text-align: left;
        margin-top: .4rem;
      }
    }
    .row{
      margin-bottom: .4rem;
      .label-name{
        width: 3.5rem;
        font-size: .7rem;
        color: #8F8F94;
        display: inline-block;
        margin: 0;
      }
      .cont{
        font-size: .7rem;
        color: #222;
      }
      .copy-btn{
        font-size: .7rem;
        color: $base-color;
        margin-left: .15rem;
        cursor: pointer;
      }
    }
  }
}
@media screen and (min-width:750px){
  .container{
    padding-top: 1px;
    position: relative;
    h3{
      width: 334px;
      margin: 16px auto 28px;
      font-size: 24px;
      color: #222;
      text-align: left;
    }
  }
  .section{
    width: 334px;
    margin: 0 auto;
  }
  .payment-section{
    .item{
      max-width: 334px;
      background: #F4F9FD;
      border-radius: 10px;
      border: 2px solid #F4F9FD;
      margin-bottom: 28px;
      padding: 24px 20px;
      box-sizing: border-box;
      cursor: pointer;
      @include flex-align();
      .icon{
        width: 24px;
        height: 24px;
      }
      .item-name{
        line-height: 1.2;
        font-size: 16px;
        color: #222;
        margin-left: 15px;
      }
    }
    .item-active{
      border: 2px solid $base-color;
    }
  }
  .payment-list{
    .item{
      width: 300px;
      height: 162px;
      background: #FFFFFF;
      border-radius: 16px;
      border: 2px solid #D8E0F0;
      margin: 0 auto 10px;
      padding: 16px;
      // padding: 22px 5px 22px 22px;
      &:last-child{
        margin-bottom: 0;
      }
      &-active{
        border: 3px solid $base-color;
      }
      .name{
        line-height: 1.4;
        font-size: 22px;
        color: #222;
        margin-bottom: 8px;
      }
      .account-name{
        margin-bottom: 16px;
      }
    }
    .collection-payment{
      display: flex;
      align-items: center;
    }
    .qr-code{
      width: 100px;
      height: 100px;
      margin-right: 20px;
    }
    .info{
      .tips{
        line-height: 1.4;
        font-size: 16px;
        color: #8F8F94;
        text-align: left;
        margin-top: 8px;
      }
    }
    .row{
      margin-bottom: 8px;
      .label-name{
        width: 70px;
        font-size: 14px;
        color: #8F8F94;
        display: inline-block;
        margin: 0;
      }
      .cont{
        font-size: 14px;
        color: #222;
      }
      .copy-btn{
        font-size: 14px;
        color: $base-color;
        margin-left: 3px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/payment.vue